import React from "react";
import { Container, Typography, Button } from "@material-ui/core";
import Divider from "../components/Common/Divider";
import Footer from "../components/Common/Footer";
import NormalLink from "../components/Common/NormalLink";
import { PrivacyPolicyPageHead } from "../components/Common/PagesHead";

export default function Privacy() {
  return (
    <div>
      <PrivacyPolicyPageHead />
      <Container maxWidth="xl">
        <Divider />
        <Divider />
        <Typography variant="h4" align="center">
          隱私權政策
        </Typography>
        <Divider />
        <Typography variant="body1">
          感謝您使用本服務。當您完成註冊或使用了本公司的服務，代表您同意並信任本公司對您個人資料的保存與處理。
        </Typography>
        <Divider />
        <Typography variant="body1">
          為保障使用者使用本服務之隱私權及相關權利，本公司將遵循中華民國個人資料保護法之要求，保護及尊重您的個人隱私。
          依照個人資料保護法第8條規定，本服務之隱私權保護政策（下稱「本政策」）將幫助您了解，我們如何蒐集、處理、利用及保護個人資料。一旦您開始使用本服務，即表示您已同意本公司依照本隱私權政策蒐集、處理、利用及保護您的個人資料。為保障您的權益，請詳閱以下內容：
        </Typography>

        <Divider />
        <Typography variant="body1">
          <Typography variant="h5">一、蒐集和利用個人資料</Typography>
          <Divider />
          本公司依據個人資料保護法規定，向您告知以下事項：
          <br />
          <br />
          (1) 蒐集方式
          <br />
          本公司將於您使用本網站時透過您的電腦、手機或其他裝置蒐集您的資訊。
          <br />
          <br />
          (2) 蒐集目的
          <br />
          蒐集的目的在進行代理與仲介業務；非公務機關依法定義務所進行個人資料之蒐集處理及利用；契約、類似契約關係或其他法律關係事務；消費者、客戶管理與服務；財產管理；商業與技術資訊；會計與相關服務；網路購物及其他電子商務服務；廣告或商業行為管理；輔助性與後勤支援管理；調查、統計與研究分析；其他經營合於營業登記項目或組織章程所定之業務（法定特定目的項目編號為○二Ｏ、Ｏ六三、Ｏ六九、Ｏ九Ｏ、○九四、Ｏ九八、一二九、一四八、一五Ｏ、一五二、一五七、一八一）
          <br />
          <br />
          (3) 蒐集資料
          <ul style={{ listStyle: "none" }}>
            i. 本公司蒐集您的資料包括：
            <ul style={{ listStyle: "none" }}>
              <li>
                ・C001辨識個人者:如身分資料，例如姓名、電話號碼、銀行帳戶號碼、信用卡號碼、身分證字號、身分證影本、外籍人士護照號碼、護照影本、通訊軟體帳號、網路平臺申請之帳號、通訊及戶籍地址等；
              </li>
              <li>
                ・C002辨識財務者：如信用卡或金融機構帳戶資訊。特徵資料，例如性別、出生日期等；
              </li>
              <li>
                ・C003政府資料中之辨識者：如身分證統一編號、統一證號、稅籍編號、證照號碼、護照號碼等。
              </li>
              <li>
                ・C011個人描述：如年齡、性別、出生年月日、出生地、國籍等。
              </li>
              <li>・C038職業：如學校校長、民意代表或其他各種職業等</li>
              <li>
                ・C101資料主體之商業活動：如商業種類、提供或使用之財貨或服務、商業契約等。
              </li>
              <li>
                ・C052資格或技術：如學歷資格、專業技術、特別執照（如飛機駕駛執照等）、政府職訓機構學習過程、國家考試、考試成績或其他訓練紀錄等。
              </li>
              <li>
                ・C102約定或契約：如關於交易、商業、法律或其他契約、代理等。
              </li>
            </ul>
            <li>
              ii.
              當您使用本服務時，我們將蒐集您於本公司網站或軟體上活動的相關資料。
            </li>
            <li>
              iii.
              您可能提供本公司由第三方儲存的個人資料（例如：社群媒體）。本公司能取得的資訊視不同的第三方網站及您對該網站的隱私權設定而有所不同。一旦您將本公司連接第三方管理之帳戶相連，並授權本公司存取資訊，您即同意本公司得依本隱私權保護政策蒐集、儲存、使用該等資訊。
            </li>
            <li>
              iv.
              我們也自動蒐集您使用本服務時，所使用的某些電腦、設備及瀏覽的資訊。這些資訊被集結在提供使用者瀏覽行動與模式的統計資料，並非針對個人使用。這些個人資料包括電腦或行動裝置資訊，包括但不限於識別碼、裝置名稱與類型、啟動系統、作業系統、IP位置、地點、行動網路資訊及一般網頁登入資訊（例如：瀏覽類型、網站流量及您存取之網頁）；
            </li>
          </ul>
        </Typography>
        <Divider />
        <Typography variant="body1">
          <Typography variant="h5">
            二、個人資料之期限、地區、對象與使用方法
          </Typography>
          <Divider />
          本公司依據個人資料保護法規定，向您告知以下事項：
          <ul style={{ listStyle: "none" }}>
            <li>
              (1)
              期限：蒐集個人資料特定目的持續期間、依法或依契約約定之資料留存屆滿期限、或本公司訂定之屆滿期限，以其中時間較長者為準。
            </li>
            <li>
              (2)
              地區：台灣及任何本服務所及之地區，包含日後於台灣以外依本公司之商業判斷而有必要使用該等個人資料之地區。
            </li>
            <li>
              (3) 利用對象及方法：
              <ul style={{ listStyle: "none" }}>
                <li>
                  i.
                  個人資料將用於本服務之後台管理的檢索查詢功能，並將作為商業行銷、媒介服務、金流服務、物流服務、行銷宣傳以及為推展本服務之必要範圍內而為的身分辨識。使用者個人關於本服務之使用記錄，亦將作為修改、變更、擴張本服務內容與項目的開發基礎。
                </li>
                <li>
                  ii.
                  個人資料將作為各種推播資訊、個人化服務以及本公司市場調查之基礎，包括但不限於透過電子郵件、實體郵件、電話與簡訊等方式提供與本服務或與本服務有關之合作廠商的資訊、分析與統整使用者族群特性、調查使用頻率與回流資訊等等應用。
                </li>
                <li>
                  iii.
                  其他於特定目的與使用類別之範圍內，基於推廣本服務之業務需求，而由本公司以電腦化或其他相類之數據方式處理、利用之行為。
                </li>
                <li>
                  iv.
                  防範及調查可能的違法活動及/或對本條款之違反，監測帳戶可能發生的違規事件及/或可能傷害本公司或使用者之惡意軟體或其他活動。
                </li>
                <li>v. 其他符合個人資料保護法第20條規定之利用。</li>
                <li>
                  vi.
                  您亦同意本公司得將使用者之個人資料，揭露、分享或提供給與本公司具備契約上合作關係之第三方及其關係企業，或與本公司進行共同行銷或共同促銷之合作對象，或與本公司有商業接觸或業務往來之任何其他機構，或希望向本公司取得或轉讓本公司任何資產與負債、承受風險或進行合併（若有任何合併）之人，進行如下之處理與利用：
                  <ul style={{ listStyle: "none" }}>
                    <li>
                      (i)
                      作為第三方各種推播資訊之基礎，包括但不限於透過電子郵件、實體郵件、電話與簡訊等方式提供第三方或其關係企業之行銷資訊。
                    </li>
                    <li>
                      (ii)
                      作為第三方或其關係企業優化服務內容之市場調查依據，並得與其內部之管理系統結合、匯入、建檔或以一定之方式備份、留存。
                    </li>
                    <li>
                      (iii)
                      其他經本公司與該第三方或其關係企業透過契約方式具體明列之其他處理或利用方式。
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
          如有上述情況，本公司於法律要求之程度下，應於透過一定之約定或政策機制，確保該第三方或其關係企業應以不低於本政策所要求之個人資料安全或維護標準，保護使用者之隱私。
          <Divider />
          如本公司認定有必要揭露個人資料，以避免人身傷害或財物損失、通報可疑違法行為或調查對本公司服務條款之違規情形，本公司亦得揭露您的個人資料。
          <Divider />
          除前述利用方式外，本公司在未取得您的同意前，不會使用您的個人資料。
        </Typography>
        <Divider />
        <Typography variant="body1">
          <Typography variant="h5">三、使用者就個人資料之權利</Typography>
          <Divider />
          依照個人資料保護法第3條規定，您得就所提供之個人資料行使下列權利：
          <ul style={{ listStyle: "none" }}>
            <li>
              (1)
              查詢或要求審閱或複製您的個人資料。本公司得依法收取必要之成本與費用。
            </li>
            <li>
              (2)
              要求本公司補充或更正您的個人資料。行使本項權利時，您應依法提出合理解釋。
            </li>
            <li>
              (3) 要求本公司停止蒐集、處理或使用、或刪除您的個人資料。
              <br />
              若您希望行使上述權利，您可將要求寄至：[請確認聯絡信箱]，本公司將根據您的要求處理。
              <br />
              然於本公司尚未查證您為本人前，您不得申請查詢、複製、請求閱覽或申請變動不屬於本人之個人資料及帳號內容。
              <br />
              您可隨時依據前述規定，要求停止蒐集、處理、利用或刪除屬於您的個人資料，然資料一旦經停止蒐集、處理、利用或刪除者，本公司有權向您終止本服務。若刪除您的資料可能會影響本公司服務、影響本公司的法定義務，或是刪除可能會影響對其他使用者的保護，本公司有權以封存個人資料的方式取代。
              <br />
              您了解並同意，於您請求變更、刪除或異動個人資料時，如本公司認定此舉將妨害國家重大利益、公務機關執行法定職務、蒐集機關或第三人重大利益，或本公司因執行職務或業務之必要而需繼續保留您的個人資料時，本公司有權拒絕之，並視情況可能改以其他方式（例如：封存您的個人資料）處理，待日後前述情況消失後，再依您的請求變更、刪除或異動您的個人資料。
              <br />
              您得自由選擇是否提供個人資料予本公司，惟一旦您拒絕提供完成註冊程序所需之必要資料，或所提供之資料不完整，將導致本服務無法執行，本公司得拒絕您對相關服務之申請。
            </li>
          </ul>
        </Typography>
        <Divider />
        <Typography variant="body1">
          <Typography variant="h5">
            四、如何管理和控制收集來的使用者資料
          </Typography>
          <Divider />
          本公司會致力於保護使用者的資料，本公司依法提供合理之技術及措施保護個人資料及其他資訊，以避免個人資料之喪失、誤用、未經授權使用、存取、揭露、變更或毀損（例如：採用防火牆及數據加密、建築門禁或資料存取限制等物理上控管、僅將個人資料對為職務上有必要知悉之員工開放）。
          <Divider />
          針對與本公司合作，而依本政策取得分享、使用使用者個人資料權限之第三方，本公司亦將比照前項之要求，使第三方對使用者的個人資料負擔一定之保密與維護義務，然因可歸責於第三方自身之行為，造成使用者權益受損者，本公司概不負擔任何賠償責任。
          <Divider />
          除依政府或法令要求，以及本公司因本政策之揭示，而得將資料分享或提供予第三方使用外，本公司將對個人資料負擔保密義務。
        </Typography>
        <Divider />
        <Typography variant="body1">
          <Typography variant="h5">五、COOKIE</Typography>
          <Divider />
          您同意本公司有權允許某些在本公司網站上刊登廣告的其他公司在您的電腦上設定並存取Cookie，其他公司將根據其自訂的隱私權政策使用其Cookie，並非依據本公司之隱私權保護政策。廣告主或其他公司不能存取本公司的Cookie。
          <Divider />
          本公司有時可能會執行Cookie或其他功能，讓本公司或第三方能夠收集或分享資訊，進而協助本公司改進所提供的本服務，或是協助本公司提供新的服務及功能。Cookie是我們傳送至您的電腦或行動裝置的識別碼，可以讓我們識別您的電腦或裝置，同時告訴我們本服務或網站的使用或造訪方式及時間、造訪人次，並追蹤我們網站中的活動。我們可能會將Cookie資訊與個人資料連結起來。
          <Divider />
          若您要拒絕Cookie的使用，請選擇瀏覽器上的適當設定。不過請注意，如果您這麼做，可能無法使用本服務的完整功能。
        </Typography>
        <Divider />
        <Typography variant="body1">
          <Typography variant="h5">六、其他</Typography>
          <Divider />
          本服務可能包含其他網站或網頁的連結，或使用第三人提供之服務，若您使用本服務之同時，也使用其他附加功能、外掛程式或第三方提供之應用程式（下稱「
          <b>應用程式</b>
          」），該等網站、網頁連結或應用程式可能獲取某些您的個人資料。對於此等不屬本公司之網站、連結或應用程式，您應了解其蒐集個人資料之行為，概與本公司無關。
          <Divider />
          如您授權第三方網站或應用程式存取您在本公司的帳戶，該第三方可能會取得您提供予本公司的資訊，請注意該等第三方網站或應用程式可能有自訂的隱私權政策，該第三方網站或應用程式對於您的個人資料之相關處理，本公司概不負責。
          <Divider />
          若本服務日後由本公司外之第三人經營承接，或本公司被第三人收購或合併，將依據本政策對個人資料之維護要求，移交您的個人資料。
        </Typography>
        <Divider />
        <Typography variant="body1">
          <Typography variant="h5">七、隱私權政策修訂</Typography>
          <Divider />
          本公司可能會不定時修改本隱私權政策。本公司對隱私權政策的修改均會揭露在此頁面，您應於註冊或使用本服務前仔細閱讀本隱私權政策之全部條款，並定期檢閱本公司有關隱私權政策之更新公告。
        </Typography>
        <Divider />
        <div style={{ textAlign: "right" }}>
          <NormalLink href="/">
            <Button color="primary" variant="outlined" size="large">
              返回首頁
            </Button>
          </NormalLink>
        </div>
        <Divider />
        <Divider />
      </Container>
      <Footer />
    </div>
  );
}

/**
 * https://github.com/lyrasoft/chinese-privacy-policy-template
 */
